import React, { Component } from 'react';
import { isEmpty, isWaterDevice } from '../../../Common/Common';
import Switch from '../../../Part_Sample/Switch';
import ConfirmMessage from '../../../Part_Sample/ConfirmMessage';
import Collapsible_Point_Selection from '../../util/Collapsible_Point_Selection';

export default class Water_Categories extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// show confirm prompt for delete
			is_show_confirm: false,
			// For display
			is_show_water_consumption_points: false,
			is_show_recycled_water_points: false,
		}
	}

	// set is_water_consumption_enabled in the report settings
	handleToggleWaterConsumption = () => {
		let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
		report_settings.categories.is_water_consumption_enabled = !report_settings.categories.is_water_consumption_enabled;
		this.props.handleModifyCategories(report_settings);

		this.setState({ is_show_water_consumption_points: report_settings.categories.is_water_consumption_enabled });
	}

	// set is_recycled_water_enabled in the report settings config
	handleToggleRecycledWater = () => {
		if (this.props.report_settings.categories.is_water_consumption_enabled) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			report_settings.categories.is_recycled_water_enabled = !report_settings.categories.is_recycled_water_enabled;
			this.props.handleModifyCategories(report_settings);

			this.setState({ is_show_recycled_water_points: report_settings.categories.is_recycled_water_enabled });
		}
	}

	// Add or Remove a point from water consumption category
	handleWaterConsumptionPoints = (point_id) => {
		if (!(Object.keys(window.app.state.point_list)).includes(point_id)) {
			// If the point id does not exist in current point_list
			this.setState({ is_show_confirm: true });
			this.id_to_be_deleted = { type: 'water_consumption', point_id: point_id };
		} else {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let water_consumption = report_settings.categories.water_consumption;
			if (water_consumption.points.includes(point_id)) water_consumption.points.splice(water_consumption.points.indexOf(point_id), 1);
			else water_consumption.points.push(point_id);

			report_settings.categories.water_consumption = water_consumption;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Add or Remove a point from recycled water category
	handleRecycledWaterPoints = (point_id) => {
		if (!(Object.keys(window.app.state.point_list)).includes(point_id)) {
			// If the point id does not exist in current point_list
			this.setState({ is_show_confirm: true });
			this.id_to_be_deleted = { type: 'recycled_water', point_id: point_id };
		} else {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let recycled_water = report_settings.categories.recycled_water;
			if (recycled_water.points.includes(point_id)) recycled_water.points.splice(recycled_water.points.indexOf(point_id), 1);
			else recycled_water.points.push(point_id);

			report_settings.categories.recycled_water = recycled_water;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Confirm delete a point that doesnt exist
	onConfirm = (is_pressed_ok) => {
		if (is_pressed_ok) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			if (this.id_to_be_deleted.type == 'water_consumption') {
				let water_consumption = report_settings.categories.water_consumption;
				let point_id = this.id_to_be_deleted.point_id;
				if (water_consumption.points.includes(point_id)) water_consumption.points.splice(water_consumption.points.indexOf(point_id), 1);
				report_settings.categories.water_consumption = water_consumption;
			} else if (this.id_to_be_deleted.type == 'recycled_water') {
				let recycled_water = report_settings.categories.recycled_water;
				let point_id = this.id_to_be_deleted.point_id;
				if (recycled_water.points.includes(point_id)) recycled_water.points.splice(recycled_water.points.indexOf(point_id), 1);
				report_settings.categories.recycled_water = recycled_water;
			}
			this.props.handleModifyCategories(report_settings);
		}
		this.id_to_be_deleted = null;
		this.setState({ is_show_confirm: false });
	}

	/*
	 * For Display
	 */

	// Toggle water consumption points display 
	handleShowWaterConsumptionPoints = () => {
		this.setState({ is_show_water_consumption_points: !this.state.is_show_water_consumption_points });
	}

	// Toggle recycled water points display 
	handleShowRecycledWaterPoints = () => {
		this.setState({ is_show_recycled_water_points: !this.state.is_show_recycled_water_points });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let card_style = {
			background: 'white',
			padding: '0px 10px',
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
			textAlign: 'left',
		}

		let card_shadow_style = {
			background: 'white',
			borderRadius: 20,
			padding: 10,
			width: this.props.width - 90,
			marginLeft: 'auto',
			marginRight: 'auto',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		let selected_points = [];
		selected_points = selected_points.concat(this.props.report_settings.categories.water_consumption.points);
		selected_points = selected_points.concat(this.props.report_settings.categories.recycled_water.points);

		let points_selection = {};
		// Get the selection of points
		for (let point_id in window.app.state.point_list) {
			let point_info = window.app.state.point_list[point_id];
			if (isWaterDevice(point_info)) {
				points_selection[point_id] = point_info;
			}
		}

		return (
			<div style={style}>
				<ConfirmMessage
					is_show={this.state.is_show_confirm}
					message={this.props.receiver.getString('del_conf_no_mp')}
					width={this.props.width}
					height={this.props.height}
					receiver={this.props.receiver}
					handleClick={this.onConfirm}
				/>
				<div style={{ overflow: 'auto', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', marginTop: 10, boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)', borderRadius: 20 }}>
					<div style={{ textAlign: 'left', marginLeft: 10 }}>
						<span className="header">{this.props.receiver.getString('water')}</span>
					</div>
					<div style={{ textAlign: 'left' }}>
						<span className='footnote' style={{ fontSize: 12 }}>{this.props.receiver.getString('water_setting_explanation')}</span>
					</div>
					<div style={card_style}>
						<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 120, textAlign: 'left' }} onClick={this.handleShowWaterConsumptionPoints}>
							<span style={{ fontSize: 20 }}>{this.props.receiver.getString('water_consumption')}</span>
						</div>
						<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.props.report_settings.categories.is_water_consumption_enabled} handleToggleSwitch={this.handleToggleWaterConsumption} />
						<Collapsible_Point_Selection
							is_show={this.state.is_show_water_consumption_points}
							is_disabled={!this.props.report_settings.categories.is_water_consumption_enabled}
							max_height={this.props.height - 480}
							width={this.props.width}
							points_selection={points_selection}
							handleTogglePoints={this.handleWaterConsumptionPoints}
							selected_points={this.props.report_settings.categories.water_consumption.points}
							disabled_points={selected_points.filter((s_point_id) => !this.props.report_settings.categories.water_consumption.points.includes(s_point_id))}
						/>
					</div>
					<div style={{ ...card_style, marginBottom: 10, opacity: this.props.report_settings.categories.is_water_consumption_enabled ? 1 : 0.4 }}>
						<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 120, textAlign: 'left' }} onClick={this.handleShowRecycledWaterPoints}>
							<span style={{ fontSize: 20 }}>{this.props.receiver.getString('recycled_water')}</span>
						</div>
						<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.props.report_settings.categories.is_recycled_water_enabled} handleToggleSwitch={this.handleToggleRecycledWater} />
						<Collapsible_Point_Selection
							is_show={this.state.is_show_recycled_water_points}
							is_disabled={!this.props.report_settings.categories.is_recycled_water_enabled}
							max_height={this.props.height - 480}
							width={this.props.width}
							points_selection={points_selection}
							handleTogglePoints={this.handleRecycledWaterPoints}
							selected_points={this.props.report_settings.categories.recycled_water.points}
							disabled_points={selected_points.filter((s_point_id) => !this.props.report_settings.categories.recycled_water.points.includes(s_point_id))}
						/>
					</div>
				</div>
			</div>
		)
	}
}